/**
 * @prettier
 */
function writeLocalStorage(key, value) {
    try {
        return window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        return null;
    }
}

function readLocalStorage(key) {
    try {
        return JSON.parse(window.localStorage.getItem(key));
    } catch (e) {
        return null;
    }
}

export {writeLocalStorage, readLocalStorage};
